<div class="wrapper">
  <div class="header-section flex justify-start items-start gap-[32px]">
    @for (header of headersList | slice : 0 : 5; track header) {
      @if (header.display) {
        <div
          (click)="selectHeader(header)"
          [class.selected]="selectedTabId === header.id && !selectedTabLabel"
          class="header text-type-3 cursor-pointer text-[#60698B]"
          >
          {{ header.label }}
        </div>
      }
    }

    <div
      [class.selected]="selectedTabLabel"
      [matMenuTriggerFor]="menu"

      class="header text-type-3 cursor-pointer text-[#60698B] flex justify-center items-center"
      >
      {{ selectedTabLabel || 'More' }}
      <span>
        <mat-icon [svgIcon]="'chevron-down'" class="chevron-icon" />
      </span>
    </div>

    <mat-menu #menu="matMenu" class="tab-more-menu">
      @for (header of headersList | slice : 5; track header) {
        @if (header.display) {
          <button
            (click)="selectMenu(header)"
            [class.tab-more-menu-item--selected]="selectedTabId === header.id"
            mat-menu-item
            >
            {{ header.label }}
          </button>
        }
      }
    </mat-menu>
  </div>

  <div class="content-section">
    @switch (selectedTabId) {
      @case (0) {
        <app-account-management />
      }
      @case (1) {
        <app-contractors-list />
      }
      @case (2) {
        <app-labor-setup-screen />
      }
      @case (3) {
        <app-equipment-setup-screen />
      }
      @case (4) {
        <app-activity-type-setup-screen />
      }
      @case (5) {
        <app-settings-bid-items-list />
      }
      @case (6) {
        <app-sites-list />
      }
      @case (9) {
        <app-external-lab-setup-screen />
      }
      @case (10) {
        <app-internal-tests [project]="projectDetails" />
      }

      @case (12) {
        <app-material-test-list />
      }
      @case (13) {
        <app-project-lookups [project]="projectDetails" />
      }
      @case (14) {
        <app-reports [project]="projectDetails" />
      }
      @case (19) {
        <app-forms-list [project]="projectDetails" />
      }
      @case (15) {
        @if (isOrgAdmin) {
          @for (section of adminFlagSections; track section) {
            <section class="admin-flags" [attr.data-testid]="'project-admin-flags-' + section">
              <h3 class="section-heading">{{ section }}</h3>
              @for (flag of flagsInSection(section); track flag.key) {
                <div
                  class="admin-flag-setting"
                  [class.admin-flag-setting--dependent]="!!flag.requires"
                  [attr.data-testid]="'admin-flag-' + flag.key"
                >
                  <div class="setting-copy">
                    <div class="setting-title">{{ flag.title }}</div>
                    <div class="setting-description">{{ flag.description }}</div>
                  </div>
                  <mat-slide-toggle
                    [checked]="adminFlagState[flag.key]"
                    (change)="toggleAdminFlag(flag, $event)"
                    color="primary"
                  />
                </div>
              }
            </section>
          }
          <app-project-settings [project]="projectDetails" />
        }
      }
      @case (16) {
        <app-project-billing-settings [project]="projectDetails" />
      }
      @case (17) {
        <app-map-layers-list [project]="projectDetails" />
      }
      @case (18) {
        @if (projectDetails?.id) {
          <app-project-archive [projectId]="projectDetails.id" />
        }
      }
      @case (20) {
        @if (projectDetails?.id) {
          <app-project-arcgis-push [projectId]="projectDetails.id" />
        }
      }
    }
  </div>
</div>
